import { format } from 'date-fns';

/**
 * Formats a date to a user-friendly long format
 * Example: "January 15, 2024"
 *
 * @param date - Date to format
 * @returns Formatted date string
 */
export const formatLongDate = (date: Date): string => {
  return format(date, 'MMMM d, yyyy');
};

/**
 * Formats a date to a short format
 * Example: "Jan 15, 2024"
 *
 * @param date - Date to format
 * @returns Formatted date string
 */
export const formatShortDate = (date: Date): string => {
  return format(date, 'MMM d, yyyy');
};

